import React from 'react'
import { Link } from "react-router-dom";

const ITRChargeValueCalculationUI = ({ chargeValueCalculation, toggleEditable, editable }) =>
  <div id='itrChargeValue' className='g_m_top_200'>
    <span className='g_flex_h'>
      <b className='g_large'>Charge Value Calculation</b>
      {/* <a href='#'>Details</a> */}
      <Link to='#' onClick={toggleEditable}>Details</Link>
    </span>
    <table className='g_table g_m_top_100'>
      <tbody>
        {
          chargeValueCalculation &&
          <>
            <RowUI
              cvc='chargeValueFormula'
              value={chargeValueCalculation.chargeValueTotal}
              formula={chargeValueCalculation.chargeValueFormula}
              total={true}
              editable={editable}
            />
            <RowUI
              cvc='assetTotal'
              value={chargeValueCalculation.assetTotal}
              total={true}
              editable={editable}
            />
            <RowUI
              cvc='asset1Value'
              value={chargeValueCalculation.asset1Value}
              formula={chargeValueCalculation.asset1Formula}
              editable={editable}
            />
            <RowUI
              cvc='asset2Value'
              value={chargeValueCalculation.asset2Value}
              formula={chargeValueCalculation.asset2Formula}
              editable={editable}
            />
            <RowUI
              cvc='asset3Value'
              value={chargeValueCalculation.asset3Value}
              formula={chargeValueCalculation.asset3Formula}
              editable={editable}
            />
            <RowUI
              cvc='asset4Value'
              value={chargeValueCalculation.asset4Value}
              formula={chargeValueCalculation.asset4Formula}
              editable={editable}
            />
            <RowUI
              cvc='asset5Value'
              value={chargeValueCalculation.asset5Value}
              formula={chargeValueCalculation.asset5Formula}
              editable={editable}
            />
            <RowUI
              cvc='liabilityTotal'
              value={chargeValueCalculation.liabilityTotal}
              total={true}
              editable={editable}
            />
            <RowUI
              cvc='liability1Value'
              value={chargeValueCalculation.liability1Value}
              formula={chargeValueCalculation.liability1Formula}
              editable={editable}
            />
            <RowUI
              cvc='liability2Value'
              value={chargeValueCalculation.liability2Value}
              formula={chargeValueCalculation.liability2Formula}
              editable={editable}
            />
            <RowUI
              cvc='liability3Value'
              value={chargeValueCalculation.liability3Value}
              formula={chargeValueCalculation.liability3Formula}
              editable={editable}
            />

          </>
        }
      </tbody>
    </table>
  </div>

const RowUI = ({ cvc, value, formula, total, editable }) =>
  <>
    <tr className={total && 'g_table_total'}>
      <td>
        <Desc cvc={cvc} />
      </td>
      <td className='g_text_right'>
        {value}
      </td>
    </tr>
    {
      formula && editable &&
      <tr>
        <td colSpan='2' className='g_muted g_small'>
          {formula}
        </td>
      </tr>
    }
  </>

const Desc = ({ cvc }) =>
  <span>
    {(() => {
      switch (cvc) {
        case 'chargeValueFormula':
          return 'Charge Value: Last audited FY Charge + (A) - (B)'
        case 'assetTotal':
          return 'On asset side: (A) sum of the following'
        case 'asset1Value':
          return '1. Receivables from 1 Apr after audited FY till date (GST revenue reconciled with bank - reconciled collections from the bank)'
        case 'asset2Value':
          return '2. Closing cash on current date (all accounts on the date of calculation)'
        case 'asset3Value':
          return '3. Shareholder loans from 1 Apr after audited FY till date'
        case 'asset4Value':
          return '4. Equity raised from 1 Apr after audited FY till date'
        case 'asset5Value':
          return '5. Capital expenditure (?)'
        case 'liabilityTotal':
          return 'On Liability side: (B) sum of the following'
        case 'liability1Value':
          return '1. Payables from 1 Apr afer audited FY till date (GST expenses reconciled wih bank - reconciled expenses paid from the bank)'
        case 'liability2Value':
          return '2. Net outstanding new loans (i.e. total debt outstanding from CIBIL as on current date minus Net Debt in audited FY)'
        case 'liability3Value':
          return '3. Operating burn for the period from 1 Apr after audited FY till date (this can be estimated based on bank statements or from audited FY extrapolated to current period for the no of months)'
        default:
          return cvc
      }
    })()}
  </span>

export default ITRChargeValueCalculationUI
